<template lang="html">
  <div class="merchant-container">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('message.report') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('message.createReport') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="Number" type="index" width="50" :label="$t('message.No')"></el-table-column>
        <el-table-column prop="reportName" :show-overflow-tooltip="true" :label="$t('message.reportName')">
          <template slot-scope="scope">
            <span v-if="scope.row.reportName == 'Terminal List'" size="small">{{ $t('message.TerminalList') }}</span>
            <span v-if="scope.row.reportName == 'Terminal Parameter'" size="small">{{ $t('message.TerminalParameter') }}</span>
            <span v-if="scope.row.reportName == 'Download Task Status'" size="small">{{ $t('message.downloadTaskStatusReport') }}</span>
            <span v-if="scope.row.reportName == 'Relocation Alert'" size="small">{{ $t('message.relocationWarningReport') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" :label="$t('message.operation')" align="center">
          <template slot-scope="scope">
            <el-button class="verifone-btn" id="createBtn" type="primary" plain icon="el-icon-plus" @click="create(scope.row)">{{ $t('message.create') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 终端参数报表新增弹框-->

    <el-dialog :title="this.title" :visible.sync="ReportDetailDialogVisible" width="66s%" @close="closeDialog">
      <div class="editApp-body-container verifone-panel">
        <div style="width: 100%">
          <el-input class="input-margin" v-model="appName" :placeholder="$t('message.appSearch')" style="width: 250px;" />
          <el-button icon="el-icon-search" @click="findAppDetail"></el-button>

          <div class="groupTerminal-table-main btn-table">
            <el-table class="group-terminal-table" :data="appTableData" max-height="350" border height="350" highlight-current-row @row-click="showRow" ref="multipleTable" stripe>
              <!-- 单选框-->
              <el-table-column label="" width="65">
                <template slot-scope="scope">
                  <el-radio class="radio" v-model="radio" :label="scope.$index">&nbsp;</el-radio>
                </template>
              </el-table-column>
              <!-- APPId -->
              <el-table-column prop="id" v-if="show" />
              <!-- APP名称 -->
              <el-table-column prop="name" :label="$t('message.appName')" width="215" />
              <!-- APP包名 -->
              <el-table-column prop="packageName" :label="$t('message.packageName')" width="215" />
              <!-- APP版本 -->
              <el-table-column prop="version" :label="$t('message.version')" width="214" />
            </el-table>
            <br />
          </div>
          <div class="submit-container">
            <el-button class="verifone-btn" plain type="primary" icon="el-icon-document" @click="submit">{{ $t('message.submit') }}</el-button>
            <el-button class="verifone-btn" plain type="primary" icon="el-icon-refresh-left" @click="cancel">{{ $t('message.cancel') }}</el-button>
          </div>
        </div>
        <!--  <group-terminal-selector :dialogVisible="groupTerminalSelectorVisible"
          @close="closeTerminalSelector" @emitTerminal="addTerminals"/> -->
      </div>
    </el-dialog>


    <!-- 下载状态报表弹框-->
    <el-dialog :title="this.taskTitle" :visible.sync="statusReportDialogVisible" width="66s%" @close="closeStatusDialog">
      <div class="editApp-body-container verifone-panel">
        <div style="width: 100%">
          <el-input class="input-margin" v-model="taskName" :placeholder="$t('message.searchDownloadTask')" style="width: 250px;" />
          <el-button icon="el-icon-search" @click="findStatusDetail"></el-button>

          <div class="groupTerminal-table-main btn-table">
            <el-table class="group-terminal-table" :data="statusTableData" max-height="350" border height="350" highlight-current-row @row-click="showStatusRow"  stripe>
              <!-- 单选框-->
              <el-table-column label="" width="65">
                <template slot-scope="scope">
                  <el-radio class="radio" v-model="statusRadio" :label="scope.$index">&nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="taskId" v-if="show" />
              <el-table-column prop="taskName" :label="$t('message.downloadTask')" width="215" />
              <el-table-column :label="$t('message.type')" prop="type" width="215">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 0" size="small">{{ $t('message.appDownload') }}</span>
                  <span v-if="scope.row.type == 1" size="small">{{ $t('message.appParam') }}</span>
                  <span v-if="scope.row.type == 2" size="small">{{ $t('message.terminalParam') }}</span>
                  <span v-if="scope.row.type == 3" size="small">{{ $t('message.appDelete') }}</span>
                  <span v-if="scope.row.type == 4" size="small">{{ $t('message.appResourceFile') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('message.createTime')" width="214" />
            </el-table>
            <br />
          </div>
          <div class="submit-container">
            <el-button class="verifone-btn" plain type="primary" icon="el-icon-document" @click="statusSubmit">{{ $t('message.submit') }}</el-button>
            <el-button class="verifone-btn" plain type="primary" icon="el-icon-refresh-left" @click="statusCancel">{{ $t('message.cancel') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { Loading } from 'element-ui';

export default {
  inject: ['reload'],
  data() {
    return {
      Number: '',
      reportName: '',
      name: '',
      version: '',
      packageName: '',
      appName: '', //app名称
      taskId:'',
      status:'',
      type:'',//下载类型
      taskName:'',//任务名称
      createTime:'',//创建时间
      researchType: 0, //0 为查询分页查询APP 1搜索APP
      ReportDetailDialogVisible: false, // 默认不显示终端参数报表弹框
      statusReportDialogVisible: false,// 默认不显示下载状态报表
      appTableData: [], //app列表
      statusTableData:[],//下载任务列表
      appselect: '', //
      multipleSelection: [], //多选框的值
      templateRadio: '', //
      templateSelection: '',
      radio: '',
      send_radio: '',
      statusRadio:'',
      status_send_radio:'',
      id: '',
      title: this.$t('message.TerminalParameter') + '   >  ' + this.$t('message.selectAPP'),
      taskTitle: this.$t('message.downloadTaskStatusReport') + '   >  ' + this.$t('message.selectDownloadTask'),
      building: this.$t('message.building'),
      chooseDownloadTask:this.$t('message.chooseDownloadTask'),
      tableData: [
        {
          reportName: 'Terminal List'
        },
        {
          reportName: 'Terminal Parameter'
        },
        {
          reportName: 'Download Task Status'
        },
        {
          reportName: 'Relocation Alert'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    create(row) {
      const that = this;
      if (row.reportName == 'Terminal List') {
       this.createReport(row.reportName);
      } else if (row.reportName == 'Download Task Status') {
        this.statusReportDialogVisible = true;
      }else if (row.reportName == 'Relocation Alert') {
        this.createReport(row.reportName);
      }
       else {
        this.ReportDetailDialogVisible = true;
      }
    },
    //终端参数弹框返回
    cancel() {
      //返回关闭弹框
      this.ReportDetailDialogVisible = false;
    },
    //下载状态弹框返回
    statusCancel(){
      this.statusReportDialogVisible = false;
    },
     //终端参数报表submit
    submit() {
      const that = this;
      let loadingInstance = Loading.service({
        lock: true,
        text: 'Loading...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      let obj = {
        appId: this.send_radio
      };
      this.$axios({
        method: 'post',
        data: obj,
        url: '/marketplace/report/createTerminalParamReport',
        headers: {
          'Accept-Language': sessionStorage.getItem('acceptLanguage')
        }
      })
        .then(response => {
          if (response.data.code == '00') {
            this.$message({
              type: 'success',
              message: that.building,
              duration: '2000'
            });
            loadingInstance.close();
            document.getElementById('createBtn').blur();
            this.ReportDetailDialogVisible = false;
            this.appName = '';
            this.tableData = [];
            this.reload();
          } else {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            this.ReportDetailDialogVisible = false;
            return;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //下载状态报表submit
    statusSubmit(){
      const that = this;
      let loadingInstance = Loading.service({
        lock: true,
        text: 'Loading...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      if(this.status_send_radio==null || this.status_send_radio==''){
       this.$message({
         type: 'warning',
         message: that.chooseDownloadTask,
         duration: '2000'
       });
       loadingInstance.close();
       return;
      }
      let obj = {
        taskId: this.status_send_radio,
        type:this.type
      };
      this.$axios({
        method: 'post',
        data: obj,
        url: '/marketplace/report/createDownloadStatusReport',
        headers: {
          'Accept-Language': sessionStorage.getItem('acceptLanguage')
        }
      })
        .then(response => {
          if (response.data.code == '00') {
            this.$message({
              type: 'success',
              message: that.building,
              duration: '2000'
            });
            loadingInstance.close();
            document.getElementById('createBtn').blur();
            this.statusReportDialogVisible = false;
            this.taskName = '';
            this.tableData = [];
            this.reload();
          } else {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            this.statusReportDialogVisible = false;
            return;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //终端参数app查询
    findAppDetail() {
      const that = this;
      let obj = {
        name: this.appName
      };

      this.$axios({
        method: 'post',
        url: '/marketplace/report/searchAppList',
        headers: {
          'Accept-Language': sessionStorage.getItem('acceptLanguage')
        },
        data: obj
      })
        .then(response => {
          if (response.data.code != '00') {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            that.appTableData = response.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //下载状态下载任务查询
    findStatusDetail(){
      const that = this;
      let obj = {
        query: this.taskName
      };

      this.$axios({
        method: 'post',
        url: '/marketplace/report/searchDownloadStatusList',
        headers: {
          'Accept-Language': sessionStorage.getItem('acceptLanguage')
        },
        data: obj
      })
        .then(response => {
          if (response.data.code != '00') {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            that.statusTableData = response.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //终端参数选择当前行
    showRow(row) {
      event.preventDefault();
      this.radio = this.appTableData.indexOf(row);
      this.send_radio = row.id;
    },
    //下载状态选择当前行
    showStatusRow(row) {
      this.statusRadio = this.statusTableData.indexOf(row);
      this.status_send_radio = row.taskId;
      this.type = row.type;
    },
    //关闭终端参数弹框
    closeDialog() {
      this.appName = '';
      this.appTableData = [];
    },
    //关闭下载任务弹框
    closeStatusDialog(){
      this.taskName ='';
      this.statusTableData = [];
    },
    //创建报表
    createReport(reportName){
      const that = this;
      let loadingInstance = Loading.service({
        lock: true,
        text: 'Loading...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      let obj = {
        reportName: reportName
      };
      this.$axios({
        method: 'post',
        url: '/marketplace/report/createReport',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
        data: obj,
        timeout: 600000
      })
        .then(res => {
          if (res.data.code == '00') {
            this.$message({
              type: 'success',
              message: that.building,
              duration: '2000'
            });
            loadingInstance.close();
            document.getElementById('createBtn').blur();
            this.reload();
            return;
          } else {
            this.$message({
              type: 'error',
              message: res.data.desc,
              duration: '3000'
            });
            loadingInstance.close();
            return;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/components/page/report/CreateTable.vue